import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import * as moment from "moment";

export class PlanningOmsFiltersComponent implements IController {
  filters: any;
  enableDates?: boolean;
  onChangeFilters: Function;

  public statusOptions: string[] = ['NotScheduled', "Scheduled"];
  public attemptOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  public isLocationSectionExpanded: boolean = false;
  public isTimeSectionExpanded: boolean = false;
  public isExecutionSectionExpanded: boolean = false;
  public isInformationSectionExpanded: boolean = false;

  constructor() {

  }

  $onInit() {
    if (!this.filters) {
      this.filters = {}
    }
  }

  onChangeFilterBy(value) {
    this.filters.filterByCreatedAt = value;
    this.filters.dueFrom = undefined;
    this.filters.dueTo = undefined;
    this.filters.createdAtFrom = undefined;
    this.filters.createdAtTo = undefined;

    if (this.filters.filterByCreatedAt) {
      this.filters.createdAtFrom = moment(this.filters.from).valueOf()
      this.filters.createdAtTo = moment(this.filters.to).valueOf()
    } else {
      this.filters.dueFrom = moment(this.filters.from).valueOf()
      this.filters.dueTo = moment(this.filters.to).valueOf()
    }
    this.onChangeFilters({filters: this.filters});
  }

  onDateChange(from, to) {
    this.filters.dueFrom = undefined;
    this.filters.dueTo = undefined;
    this.filters.createdAtFrom = undefined;
    this.filters.createdAtTo = undefined;

    this.filters.from = moment(from).valueOf();
    this.filters.to = moment(to).endOf('day').valueOf();

    if (this.filters.from >= this.filters.to) {
      this.filters.to = moment(this.filters.from).endOf('day').toDate();
    }

    if (this.filters.filterByCreatedAt) {
      this.filters.createdAtFrom = moment(from).valueOf()
      this.filters.createdAtTo = moment(to).valueOf()
    } else {
      this.filters.dueFrom = moment(from).valueOf()
      this.filters.dueTo = moment(to).valueOf()
    }
    this.onChangeFilters({filters: this.filters});
  }

  onChangeServiceAreasIds(serviceAreaIds) {
    _.set(this.filters, 'serviceAreaIds', serviceAreaIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeBranches(branchIds) {
    _.set(this.filters, 'branchIds', branchIds);
    _.unset(this.filters, 'accountIds');
    _.unset(this.filters, 'serviceAreaIds');
    this.onChangeFilters({filters: this.filters});
  }

  onChangeAccountIds(accountIds) {
    _.set(this.filters, 'accountIds', accountIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeTagNames(tagNames, isExcludeMode) {
    if (isExcludeMode) {
      _.set(this.filters, 'excludedTags', tagNames);
      _.unset(this.filters, 'tags');
    } else {
      _.set(this.filters, 'tags', tagNames);
      _.unset(this.filters, 'excludedTags');
    }
    this.onChangeFilters({filters: this.filters});
  }

  onChangeProgramTypes(programTypes) {
    _.set(this.filters, 'programTypes', programTypes);
    this.onChangeFilters({filters: this.filters});
  }

  onChangePickupDepotIds(depotIds) {
    _.set(this.filters, 'pickupDepotIds', depotIds);
    this.onChangeFilters({filters: this.filters});
  }

  onChangeDestinationDepotIds(depotIds) {
    _.set(this.filters, 'destinationDepotIds', depotIds);
    this.onChangeFilters({filters: this.filters});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningOmsFilters', {
    bindings: {
      filters: '<',
      enableDates: '<?',
      onChangeFilters: '&'
    },
    template: require('./planning-oms-filters.html').default,
    controller: PlanningOmsFiltersComponent
  });

